import { createFactory, createContext, useContext, useState } from 'react';
var createStateContext = function (defaultInitialValue) {
    var context = createContext(undefined);
    var providerFactory = createFactory(context.Provider);
    var StateProvider = function (_a) {
        var children = _a.children, initialValue = _a.initialValue;
        var state = useState(initialValue !== undefined ? initialValue : defaultInitialValue);
        return providerFactory({ value: state }, children);
    };
    var useStateContext = function () {
        var state = useContext(context);
        if (state == null) {
            throw new Error("useStateContext must be used inside a StateProvider.");
        }
        return state;
    };
    return [useStateContext, StateProvider, context];
};
export default createStateContext;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/createStateContext.js
// module id = K2UI
// module chunks = 0